import { account } from '../core/account.js';
import { device } from '../core/device.js';
import { t } from '../core/i18n.js';
import { mountWizard, card } from './add-source.js';

/* Primera pantalla de la app cuando aún no hay ninguna fuente (tras la bienvenida): el asistente «Añadir fuente» tal cual
   (¿dónde está tu contenido?) más las otras formas de traer fuentes (buscar en la red, teclear desde el móvil, la tele
   emparejada). Antes salía «Conecta tu contenido», que repetía casi lo mismo con otro aspecto. Con cuentas del servidor sin
   sesión sigue saliendo /login/ (hay que entrar primero). */

/** A dónde se va cuando no hay fuentes: a entrar con la cuenta si el servidor la exige, si no a elegir la primera fuente. */
export function firstScreen({ needsAccount = false } = {}) {
    return needsAccount ? '/login/' : '/start/';
}

/** En la web no hay red local ni mando: sin herramientas extra (en las apps están aquí «Buscar en mi red», «Añadir desde el móvil» y la tele). */
function toolsHtml() { return ''; }

export default {
    path: '/start/',
    nav: null,

    render() {
        return `<div class="page no-nav" data-name="start">
            <div class="page-content" style="padding:0">
                <div class="auth wiz-page"><div class="auth-card form" data-wiz></div><div class="auth-card form wiz-tools" data-start-tools>${toolsHtml()}</div></div>
            </div>
        </div>`;
    },

    mount(page) {
        const root = page.el;
        const router = () => window.app.views.main.router;
        const cleanup = mountWizard(root, { start: true }, () => {}) || (() => {});
        // Las otras formas de añadir solo acompañan a la primera pantalla del asistente (dentro de un grupo o un formulario estorban).
        const box = root.querySelector('[data-wiz]');
        const toolsBox = root.querySelector('[data-start-tools]');
        const syncTools = () => { toolsBox.hidden = !!box.querySelector('.wiz-back, .wiz-bottom-back'); };
        const mo = new MutationObserver(syncTools);
        mo.observe(box, { childList: true });
        syncTools();
        if (device.isTV) setTimeout(() => window.IPTV.tvnav.focusLayer(root), 120);
        return () => { mo.disconnect(); cleanup(); };
    }
};
